import React, { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Algorithm } from './components/algorithm'
import { About } from './components/about'
import { Culture } from './components/gallery'
import { Listen } from './components/listen'
import { Code } from './components/code'
import { Contact } from './components/contact'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'
import './App.css'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Algorithm data={landingPageData.Algorithm} />
      <Culture data={landingPageData.Culture} />
      <Listen data={landingPageData.Listen} />
      <Code data={landingPageData.Code} />
      <Contact data={landingPageData.Contact} />
    </div>
  )
}

export default App
